/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personas_Scope_Personal_HintInputs */



/**
* | output |
* | --- |
* | "Only you can see and use this persona." |
*
* @param {Personas_Scope_Personal_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const personas_scope_personal_hint = /** @type {((inputs?: Personas_Scope_Personal_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personas_Scope_Personal_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur du kannst diese Persona sehen und verwenden.")
	return /** @type {LocalizedString} */ ("Only you can see and use this persona.")
});